import {connect} from "react-redux";
import ReviewPJP from "./Review";
import {bindActionCreators} from "redux";
import {getAM, pjpReview} from "../../../../service/FasttagToll/action";
const mapStateToProps = (state) => ({
    PJPReviewDetails:state.FasttagToll.PJPReviewDetails,
    allAm:state.FasttagToll.allAm
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            pjpReview,
            getAM
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ReviewPJP);
